import axios from 'axios';
import { BACKEND_API } from '../config';

export const api = axios.create({
  baseURL: BACKEND_API,
  timeout: 1000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
});
